export function NoteRemove({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.83341 13.3333H10.0001M5.83341 9.99992H12.5001M10.0001 1.66659H13.3334C16.1084 1.81659 17.5001 2.84159 17.5001 6.65825V13.3333M17.5001 13.3333L12.5001 18.3333M17.5001 13.3333H15.0001C13.3334 13.3333 12.5001 14.1666 12.5001 15.8333V18.3333M2.50008 9.16678V13.3166C2.50008 16.6583 3.33341 18.3333 7.50008 18.3333H10.0001C10.1417 18.3333 12.3667 18.3333 12.5001 18.3333M5.3989 1.51351L5.6319 1.98782C5.74839 2.22081 6.03963 2.43717 6.29759 2.48709L6.6138 2.53702C7.56242 2.69512 7.78709 3.39411 7.10475 4.08477L6.8135 4.376C6.62211 4.57571 6.51395 4.95849 6.5722 5.22477L6.6138 5.39952C6.87175 6.54785 6.26431 6.98887 5.26576 6.38974L5.0494 6.26493C4.79144 6.11515 4.37539 6.11515 4.11743 6.26493L3.90107 6.38974C2.8942 6.99719 2.28675 6.54785 2.55303 5.39952L2.59463 5.22477C2.65288 4.95849 2.54472 4.57571 2.35333 4.376L2.06208 4.08477C1.37974 3.39411 1.60441 2.69512 2.55303 2.53702L2.86924 2.48709C3.11888 2.44549 3.41843 2.22081 3.53493 1.98782L3.76793 1.51351C4.21727 0.606498 4.94956 0.606498 5.3989 1.51351Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
